<template>
  <div v-if="shiurimPerCategory">
    <div class="row align-items-center mb-2">
      <div class="col-12 col-md-8 pl-md-0" v-if="showTitle">
        <h4 class="d-flex align-items-center text-center text-sm-left mb-0 homepage-shiurim-title">
          {{ shiurimPerCategory.category.name }} Shiurim
          <router-link :to="'/categories/' + shiurimPerCategory.category.url_key" v-if="!singleCategoryPage">
            <b-button class="px-4 ml-4 view-all-shiurim-button" pill>
              <span v-if="isRTL">←</span>
              {{ $_t('KW:viewAll') }}
              <span v-if="!isRTL">→</span>
            </b-button>
          </router-link>
        </h4>
      </div>

      <div class="col-12 col-md-4 pl-md-0" v-if="showFilters.name">
        <input class="form-control w-100 search-filter my-auto" v-model="filters.name" :placeholder="$_t('KW:searchShiurim')" />
      </div>
      <div class="col-12 col-md-4" v-if="showFilters.topic">
        <v-select v-if="topics" class="select-filter mb-0" v-model="filters.topic" :placeholder="$_t('KW:filterByTopic')" :options="topics" />
      </div>
      <div class="col-12 col-md-4" v-if="showFilters.speaker">
        <v-select v-if="speakers" class="select-filter" v-model="filters.speaker" :placeholder="$_t('KW:filterMagidShiur')" :options="speakers" />
      </div>
    </div>

    <div class="row" v-if="showPagination">
      <div class="col-12" v-if="shiurimPerCategory.shiurim">
        <b-pagination v-model="pagination.currentPage" :total-rows="shiurimPerCategory.shiurim_count" :per-page="perCategory" aria-controls="my-table" />
      </div>
    </div>

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
      <div class="col p-3" v-for="row in shiurimPerCategory.shiurim">
        <div class="shiurim-card custom-hover-shadow h-100">
          <shiurim-card :shiurim="row"></shiurim-card>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12" v-if="singleCategoryPage && shiurimPerCategory.shiurim">
        <b-pagination v-model="pagination.currentPage" :total-rows="shiurimPerCategory.shiurim_count" :per-page="perCategory" aria-controls="my-table" />
      </div>
    </div>
  </div>
</template>

<script>
import ShiurimCardComponent from '../partials/ShiurimCard.vue';
import _ from 'lodash';
import VueSelect from 'vue-select';

export default {
  props: {
    perCategory: { default: null },
    slug: { default: null },
    singleCategoryPage: { default: true },
    showTitle: { default: true },
    showPagination: { default: true },
    showFilters: {
      default() {
        return { name: true, speaker: true, topic: true };
      },
    },
  },
  components: {
    vSelect: VueSelect,
    ShiurimCard: ShiurimCardComponent,
  },
  data() {
    return {
      topics: null,
      speakers: null,
      pagination: {
        currentPage: 1,
        offset: 0,
      },
      filters: {
        name: null,
        topic: null,
        speaker: null,
      },
      shiurimPerCategory: null,
    };
  },
  watch: {
    'pagination.currentPage': {
      handler: _.debounce(function (page) {
        if (page === 1) {
          this.pagination.offset = 0;
        } else {
          this.pagination.offset = Number(this.perCategory) * (Number(page) - 1);
        }
        this.getData();
      }, 600),
    },
    'filters.name': {
      handler: _.debounce(function () {
        this.getData();
      }, 600),
    },
    'filters.topic': {
      handler: _.debounce(function () {
        this.getData();
      }, 600),
    },
    'filters.speaker': {
      handler: _.debounce(function () {
        this.getData();
      }, 600),
    },
  },
  mounted() {
    this.getData();

    if (!this.slug) return;

    if (this.showFilters.topic) this.getTopicsForFilter();

    if (this.showFilters.speaker) this.getSpeakersForFilter();
  },
  methods: {
    getTopicsForFilter() {
      this.$http.get('/api/shiurim/torah/' + this.slug + '/topics').then(resp => (this.topics = resp.data));
    },
    getSpeakersForFilter() {
      this.$http.get('/api/shiurim/torah/' + this.slug + '/speakers').then(resp => (this.speakers = resp.data));
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    getData() {
      let url = '/api/categories/shiurim';

      this.$http
        .get(url, {
          params: {
            limit: this.perCategory,
            offset: this.pagination.offset,
            slug: this.slug,
            filters: {
              name: this.filters.name,
              topic_id: this.filters.topic ? this.filters.topic.value : null,
              speaker_id: this.filters.speaker ? this.filters.speaker.value : null,
            },
          },
        })
        .then(resp => {
          const data = resp.data[0].shiurim;
          this.$set(this, 'shiurimPerCategory', resp.data[0]);
        });
    },
  },
};
</script>
